import { prefixClass } from 'lib/utils';
import { formatAmountCondensed } from '../../NewTable/NTCell/ValueFormatters/ValueFormatters';
import { hoverInfo, InfoArea, InfoAreaAll } from '../DashboardChart';
import './DashboardChartTooltip.scss';
import { formatRangeValues } from 'lib/reportUtils';

const DashboardChartTooltipAll = ({ keyInfo }: { keyInfo: InfoAreaAll }) => {
  const prefix = prefixClass('ks-dashboard-chart-tooltip');

  //+ ` ${hoverInfo.x},${hoverInfo.y}  ${hoverInfo.week}`

  const WeekTitleId = String(keyInfo.week).indexOf('W') > -1 ? keyInfo.week : `W${keyInfo.week}`;
  const titleForWeeks = formatRangeValues(keyInfo.date, 'KS');
  return (
    <div className={prefix()}>
      <div className={prefix('concept')}>
        <div className={prefix('date-entry-date')}>{titleForWeeks}</div>
        <div className={prefix('concept-week')}>{WeekTitleId}</div>
      </div>

      <div className={prefix('all-entry')}>
        {Object.entries(keyInfo.values)
          .reverse()
          .map(([key, value]) => (
            <div key={key} className={prefix('all-entry-item')}>
              <div className={prefix('all-entry-item-label')}>{key}</div>
              <div className={prefix('all-entry-item-value')}>{formatAmountCondensed(value || 0, true)}</div>
            </div>
          ))}
      </div>
    </div>
  );
};

const DashboardChartTooltipKey = ({ keyInfo, week }: { keyInfo: InfoArea; week: number }) => {
  const prefix = prefixClass('ks-dashboard-chart-tooltip');
  document.documentElement.style.setProperty('--ks-dashboard-chart-concept-color', `${keyInfo.color}`);
  const titleForWeeks = keyInfo.values[keyInfo.type !== 'p&l' ? week : 0]
    ? formatRangeValues(keyInfo.values[keyInfo.type !== 'p&l' ? week : 0].date, 'KS')
    : '';
  //+ ` ${hoverInfo.x},${hoverInfo.y}  ${hoverInfo.week}`
  const weekId: string = String(keyInfo.values[week]?.week || '');
  const WeekTitleId = weekId.indexOf('W') > -1 ? weekId : `W${weekId}`;
  return (
    <div className={prefix()}>
      <div className={prefix('concept')}>
        <div className={prefix('concept-label')}>{keyInfo.key}</div>
        <div className={prefix('concept-week')}>{WeekTitleId}</div>
      </div>
      <div className={prefix('date-entry')}>
        {/* {weekId && <div className={prefix('date-entry-week')}>{weekId.indexOf('W') > -1 ? weekId : `W${weekId}`}</div>} */}
        {keyInfo.values[week] && <div className={prefix('date-entry-date')}>{titleForWeeks}</div>}
      </div>
      <div className={prefix('value-entry')}>
        <div className={prefix('value-entry-label')}>Week</div>
        <div className={prefix('value-entry-value')}>
          {formatAmountCondensed(keyInfo.values[week]?.discrete || 0, true)}
        </div>
      </div>
      <div className={prefix('value-entry')}>
        <div className={prefix('value-entry-label')}>Period to Date</div>
        <div className={prefix('value-entry-value')}>
          {formatAmountCondensed(keyInfo.values[week]?.cumulative || 0, true)}
        </div>
      </div>
    </div>
  );
};

const DashboardChartTooltip = ({ hoverInfo }: { hoverInfo: hoverInfo }) => {
  if (hoverInfo.all) {
    return <DashboardChartTooltipAll keyInfo={hoverInfo.info as InfoAreaAll} />;
  } else {
    return <DashboardChartTooltipKey keyInfo={hoverInfo.info as InfoArea} week={hoverInfo.week} />;
  }
};

export default DashboardChartTooltip;
